<template>
  <div class="container" id="message-area">
    <h4 :class="errorFlag ? 'errMsg' : 'blue'">{{ message }}</h4>
  </div>
</template>

<script>
export default {
  name: 'message',
  props: {
    message: null,
    errorFlag: false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/partials/Message.vue